import Config from 'react-native-config';
import CryptoJS from 'crypto-js';

export const encryptAES = (value: any): string => {
  const payload = {
    type: typeof value,
    value,
  };

  return CryptoJS.AES.encrypt(
    JSON.stringify(payload),
    Config.AES_SECRET_KEY,
  ).toString();
};

export const decryptAES = (encryptedData: string | null): any => {
  if (!encryptedData) {
    return null;
  }

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, Config.AES_SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) {
      return null;
    }

    const parsedData = JSON.parse(decryptedText);
    return parsedData.value;
  } catch (error) {
    return null;
  }
};

export const AESencrypt = (storageKey: string, value: any) => {
  try {
    const encryptedData = encryptAES(value);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(storageKey, encryptedData);
    }
  } catch (error) {
    // console.error('AESencrypt Error:', error);
    return null;
  }
};

export const AESdecrypt = (storageKey: string) => {
  try {
    const encryptedData =
      typeof localStorage !== 'undefined'
        ? localStorage.getItem(storageKey)
        : null;
    return decryptAES(encryptedData);
  } catch (error) {
    // console.error('AESdecrypt Error:', error);
    return null;
  }
};

/**
 * Remove data from localStorage
 * @param {string} storageKey
 */
export const AESclear = (storageKey: string) => {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(storageKey);
    }
  } catch (error) {
    // console.error('AESclear Error:', error);
    return null;
  }
};

/**
 * Clear all data from localStorage
 */
export const AESclearAll = () => {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.clear();
    }
  } catch (error) {
    // console.error('AESclearAll Error:', error);
    return null;
  }
};
